import React, { useState, useEffect } from "react";
import "./index.scss";
import Dropdown from "../../static/Dropdown/Dropdown";
import { dropdownItem } from "../../static/Dropdown/types";
import { getSurfaces } from "../../services/tennisTech";
import Loading from "../../static/Loading/Loading";
import { SurfaceDetails } from "./type";
import { tennisTech as errors } from "../../helpers/errors/index";

const SurfacesTabelRow = (props: { surfaceDetails: SurfaceDetails }) => {
  const { surfaceDetails } = props;

  const [isHidden, setIsHidden] = useState(true);
  return (
    <tr>
      <td
        onClick={() => {
          setIsHidden(!isHidden);
        }}
      >
        <span className="classified-surface__surface-title">
          <span>{surfaceDetails.name}</span>
          <button
            className={`accordion__toggle-btn ${
              isHidden ? "accordion__toggle-btn--hidden" : null
            }`}
          />
        </span>
      </td>
      <td
        className={`classified-surface__mobile-table-cell ${
          isHidden ? "classified-surface__mobile-table-cell--hidden" : null
        }`}
      >
        <span className="classified-surface__type-pressure">
          <span>Pace: {surfaceDetails.pace}</span>
          <span>
            Type:&nbsp;<span>{surfaceDetails.type}</span>
          </span>
        </span>
        <span>
          <span>
            <span className="classified-surface__vertical classified-surface__manufacturer">
              <strong className="classified-surface__manufacturer-label">
                Manufacturer:
              </strong>
              <strong>{surfaceDetails.manufacturerName}</strong>
              <span className="classified-surface__manufacturer-address">
                {surfaceDetails.manufacturerAddress}
              </span>
              <span>
                <strong>Tel:&nbsp;</strong>{" "}
                <a href={`tel:${surfaceDetails.manufacturerTelephone}`}>
                  {surfaceDetails.manufacturerTelephone}
                </a>
              </span>
              <span>
                <strong>Fax:&nbsp;</strong> {surfaceDetails.manufacturerFax}
              </span>
              <span>
                <strong>Email:&nbsp;</strong>
                <a href={`mailto:${surfaceDetails.manufacturerEmail}`}>
                  {surfaceDetails.manufacturerEmail}
                </a>
              </span>
              <span>
                <strong>Website:&nbsp;</strong>{" "}
                <a href={surfaceDetails.manufacturerWebsite} target="_blank">
                  {surfaceDetails.manufacturerWebsite}
                </a>
              </span>
              <span>
                <strong>Expires:&nbsp;</strong> {surfaceDetails.expiryDate}
              </span>
            </span>
          </span>
        </span>
      </td>
      <td className="classified-surface__desktop-table-cell">
        <span>{surfaceDetails.pace}</span>
      </td>
      <td className="classified-surface__desktop-table-cell">
        <span>{surfaceDetails.type}</span>
      </td>
      <td className="classified-surface__desktop-table-cell">
        <span className="classified-surface__manufacturer-details">
          <span className="classified-surface__vertical">
            <strong>{surfaceDetails.manufacturerName}</strong>
            <span>{surfaceDetails.manufacturerAddress}</span>
          </span>
          <span className="classified-surface__vertical classified-surface__manufacturer-contact">
            <span>
              <strong>Tel:</strong>{" "}
              <a href={`tel:${surfaceDetails.manufacturerTelephone}`}>
                {surfaceDetails.manufacturerTelephone}
              </a>
            </span>
            <span>
              <strong>Fax:</strong> {surfaceDetails.manufacturerFax}
            </span>
            <span>
              <strong>Email:</strong>{" "}
              <a href={`mailto:${surfaceDetails.manufacturerEmail}`}>
                {surfaceDetails.manufacturerEmail}
              </a>
            </span>
            <span>
              <strong>Website:</strong>{" "}
              <a href={surfaceDetails.manufacturerWebsite} target="_blank">
                {surfaceDetails.manufacturerWebsite}
              </a>
            </span>
          </span>
        </span>
      </td>
      <td className="classified-surface__desktop-table-cell">
        <span>{surfaceDetails.expiryDate}</span>
      </td>
    </tr>
  );
};

const ClassifiedSurfaces = (props: {
  applyLink: string;
  applyLinkName: string;
}) => {
  const { applyLink, applyLinkName } = props;
  const [clSurfaces, setClSurfaces] = useState<SurfaceDetails[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [typeFilter, setTypeFilter] = useState();
  const [textFilter, setTextFilter] = useState();
  const [paceFilter, setPaceFilter] = useState();

  // pagination items
  const [itemsShown, setItemsShown] = useState(5);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const itemsRemaining = clSurfaces.length - itemsShown;
  const pagerFlag = itemsRemaining > 0;

  const perPage = [
    { label: "5", value: 5 },
    { label: "10", value: 10 },
    { label: "20", value: 20 },
    { label: "50", value: 50 }
  ].filter(option => clSurfaces.length / option.value > 1);

  const handlePager = ({ value }: any) => {
    setItemsPerPage(value);
    setItemsShown(value);
  };

  const handleProgressiveLoad = () => {
    setItemsShown(itemsShown + itemsPerPage);
  };
  // pagination items end

  useEffect(() => {
    setIsLoading(true);
    setIsError(false);
    getSurfaces()
      .then(data => {
        setIsLoading(false);
        setClSurfaces(data);
      })
      .catch(() => {
        setIsLoading(false);
        setIsError(true);
      });
  }, []);

  let surfaceTypeOptions: dropdownItem[] = [];

  const surfaceTypes = new Set(clSurfaces.map(item => item.type));
  surfaceTypes.forEach(value => {
    surfaceTypeOptions.push({
      label: value,
      value
    });
  });

  surfaceTypeOptions.sort(function(a, b) {
    if (a.label > b.label) {
      return 1;
    }
    if (b.label > a.label) {
      return -1;
    }
    return 0;
  });

  surfaceTypeOptions.unshift({
    label: "All",
    value: "ALL"
  });

  let surfacePaceOptions: dropdownItem[] = [
    {
      label: "All",
      value: "ALL"
    }
  ];

  const surfacePaces = new Set(clSurfaces.map(item => item.pace));
  surfacePaces.forEach(value => {
    surfacePaceOptions.push({
      label: value,
      value
    });
  });

  surfacePaceOptions.sort(function(a, b) {
    if (a.label > b.label) {
      return 1;
    }
    if (b.label > a.label) {
      return -1;
    }
    return 0;
  });

  return (
    <div className="classified-surface">
      <div className="classified-surface__filters">
        <div className="classified-surface__filters-search">
          <Dropdown
            className="dropdown--pace-filter"
            placeholder="Pace"
            options={surfacePaceOptions}
            onChange={value => {
              setPaceFilter(value.value);
            }}
          />
          <Dropdown
            className="dropdown--type-filter"
            placeholder="Type"
            options={surfaceTypeOptions}
            onChange={value => {
              setTypeFilter(value.value);
            }}
          />
          <input
            className="classified-surface__search"
            type="text"
            placeholder="Search"
            onChange={e => {
              setTextFilter(e.target.value);
            }}
          />
        </div>
        <h3 className="classified-surface__heading">Surfaces</h3>
        <a className="btn" href={applyLink}>
          {applyLinkName}
        </a>
      </div>
      <div className="approved-balls__section">
        {isError ? (
          <p className="error-text">{errors.surfacesCatchMessage}</p>
        ) : null}
        {isLoading ? <Loading /> : null}
        {clSurfaces.length !== 0 && !isLoading ? (
          <>
            <table className="classified-surface__table">
              <thead>
                <tr>
                  <th>
                    <span>Surface</span>
                  </th>
                  <th>
                    <span className="classified-surface__made-in-title">
                      Pace
                    </span>
                  </th>
                  <th>
                    <span>Type</span>
                  </th>
                  <th>
                    <span>Manufacturer</span>
                  </th>
                  <th>
                    <span className="classified-surface__made-in-title">
                      Expires
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {clSurfaces
                  .filter(value => {
                    if (!typeFilter || typeFilter === "ALL") {
                      return true;
                    } else {
                      return value.type === typeFilter;
                    }
                  })
                  .filter(value => {
                    if (!textFilter) {
                      return true;
                    } else {
                      return value.name
                        .toLowerCase()
                        .includes(textFilter.toLowerCase());
                    }
                  })
                  .filter(value => {
                    if (!paceFilter || paceFilter === "ALL") {
                      return true;
                    } else {
                      return value.pace === paceFilter;
                    }
                  })
                  .slice(0, itemsShown)
                  .map((details, index) => {
                    return (
                      <SurfacesTabelRow key={index} surfaceDetails={details} />
                    );
                  })}
              </tbody>
            </table>
            <div className="pagination-container">
              {pagerFlag ? (
                <>
                  <button onClick={handleProgressiveLoad} className="btn">
                    Show {itemsPerPage} more
                  </button>
                  <div className="pager">
                    <span className="pager__tablet-text">Showing</span>
                    <Dropdown
                      placeholder={itemsPerPage as any}
                      options={perPage}
                      value={itemsPerPage as any}
                      onChange={handlePager}
                    />
                    <span>items per page</span>
                  </div>
                </>
              ) : null}
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default ClassifiedSurfaces;
